import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "h-screen w-screen overflow-hidden bg-[var(--bg-primary)] text-[var(--text-primary)]" }
const _hoisted_2 = { class: "flex h-full flex-col md:flex-row" }
const _hoisted_3 = { class: "w-full shrink-0 border-b border-[var(--border-color)] bg-[var(--bg-secondary)]/60 backdrop-blur md:h-full md:w-[320px] md:border-b-0 md:border-r" }
const _hoisted_4 = { class: "flex flex-wrap items-center justify-between gap-2 px-4 py-4" }
const _hoisted_5 = { class: "max-h-[34vh] overflow-y-auto px-2 pb-4 md:h-[calc(100vh-72px)] md:max-h-none" }
const _hoisted_6 = {
  key: 0,
  class: "px-3 py-2 text-sm text-[var(--text-secondary)]"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "px-3 pt-3 text-xs font-semibold uppercase tracking-wide text-[var(--text-secondary)]" }
const _hoisted_9 = { class: "mt-2 space-y-1" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "truncate font-medium" }
const _hoisted_12 = { class: "truncate text-xs text-[var(--text-secondary)]" }
const _hoisted_13 = {
  key: 0,
  class: "px-3 py-3 text-sm text-[var(--text-secondary)]"
}
const _hoisted_14 = { class: "relative flex h-full min-w-0 flex-1 flex-col" }
const _hoisted_15 = {
  ref: "scrollEl",
  class: "flex-1 overflow-y-auto px-4 py-4 sm:px-6 sm:py-6"
}
const _hoisted_16 = { class: "mx-auto w-full max-w-3xl" }
const _hoisted_17 = {
  key: 0,
  class: "flex min-h-[60vh] flex-col items-center justify-center gap-6"
}
const _hoisted_18 = { class: "grid w-full grid-cols-1 gap-3 sm:grid-cols-2" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "font-semibold" }
const _hoisted_21 = { class: "mt-1 text-sm text-[var(--text-secondary)]" }
const _hoisted_22 = {
  key: 1,
  class: "space-y-6"
}
const _hoisted_23 = { class: "min-w-0 flex-1" }
const _hoisted_24 = { class: "rounded-2xl border border-[var(--border-color)] bg-white/5 px-4 py-3" }
const _hoisted_25 = {
  key: 1,
  class: "whitespace-pre-wrap text-sm leading-relaxed"
}
const _hoisted_26 = {
  key: 0,
  class: "flex items-center gap-3 text-sm text-[var(--text-secondary)]"
}
const _hoisted_27 = {
  key: 1,
  class: "rounded-xl border border-red-500/40 bg-red-500/10 p-3 text-sm text-red-200"
}
const _hoisted_28 = { class: "border-t border-[var(--border-color)] bg-[var(--bg-primary)]/80 backdrop-blur" }
const _hoisted_29 = { class: "mx-auto w-full max-w-3xl px-4 py-4 sm:px-6" }
const _hoisted_30 = { class: "relative" }
const _hoisted_31 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MarkdownMessage = _resolveComponent("MarkdownMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("aside", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "inline-flex items-center gap-2 rounded-lg bg-white/5 px-3 py-2 text-sm font-medium text-[var(--text-primary)] hover:bg-white/10",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createNewSession && _ctx.createNewSession(...args)))
          }, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("span", { class: "text-lg leading-none" }, "+", -1),
            _createElementVNode("span", null, "Nova conversa", -1)
          ]))]),
          _createVNode(_component_router_link, {
            to: "/dashboard",
            class: "rounded-lg px-3 py-2 text-sm text-[var(--text-secondary)] hover:bg-white/10",
            title: "Voltar ao Dashboard"
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode(" Voltar ", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.loadingChats)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Carregando conversas…"))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedSessions, (group) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: group.label
                  }, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(group.label), 1),
                    _createElementVNode("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (s) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: s.sessionId,
                          class: _normalizeClass(["w-full rounded-lg px-3 py-2 text-left text-sm transition hover:bg-white/10", s.sessionId === _ctx.activeSessionId ? 'bg-white/10' : '']),
                          onClick: ($event: any) => (_ctx.openSession(s.sessionId))
                        }, [
                          _createElementVNode("div", _hoisted_11, _toDisplayString(s.title || `Sessão ${s.sessionId.slice(0, 8)}`), 1),
                          _createElementVNode("div", _hoisted_12, " Atualizada: " + _toDisplayString(_ctx.formatShort(s.updatedAt)), 1)
                        ], 10, _hoisted_10))
                      }), 128))
                    ])
                  ], 64))
                }), 128)),
                (_ctx.groupedSessions.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Nenhuma conversa ainda. "))
                  : _createCommentVNode("", true)
              ]))
        ])
      ]),
      _createElementVNode("main", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            (_ctx.messages.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex flex-col items-center gap-3 text-center" }, [
                    _createElementVNode("img", {
                      src: "/logo.png",
                      alt: "Logo",
                      class: "h-14 w-14 rounded-2xl object-contain bg-white/5 p-2"
                    }),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", { class: "text-xl font-semibold" }, "Assistente de IA"),
                      _createElementVNode("div", { class: "text-sm text-[var(--text-secondary)]" }, " Produtividade e análise de dados para o seu SaaS. ")
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestions, (s) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: s.title,
                        class: "rounded-xl border border-[var(--border-color)] bg-white/5 p-4 text-left hover:bg-white/10",
                        onClick: ($event: any) => (_ctx.applySuggestion(s.prompt))
                      }, [
                        _createElementVNode("div", _hoisted_20, _toDisplayString(s.title), 1),
                        _createElementVNode("div", _hoisted_21, _toDisplayString(s.description), 1)
                      ], 8, _hoisted_19))
                    }), 128))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (m) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: m.id,
                      class: "flex gap-3"
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["mt-1 h-8 w-8 shrink-0 rounded-full flex items-center justify-center text-xs font-bold", m.role === 'user' ? 'bg-blue-600 text-white' : 'bg-emerald-600 text-white'])
                      }, _toDisplayString(m.role === 'user' ? 'EU' : 'IA'), 3),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          (m.role !== 'user')
                            ? (_openBlock(), _createBlock(_component_MarkdownMessage, {
                                key: 0,
                                content: m.content
                              }, null, 8, ["content"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(m.content), 1))
                        ])
                      ])
                    ]))
                  }), 128)),
                  (_ctx.isThinking)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [...(_cache[8] || (_cache[8] = [
                        _createElementVNode("span", { class: "inline-flex h-2 w-2 animate-pulse rounded-full bg-emerald-400" }, null, -1),
                        _createElementVNode("span", null, "A IA está pensando…", -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  (_ctx.errorMessage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.errorMessage), 1))
                    : _createCommentVNode("", true)
                ]))
          ])
        ], 512),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.draft) = $event)),
                rows: "1",
                placeholder: "Digite uma mensagem…",
                class: "w-full resize-none rounded-2xl border border-[var(--border-color)] bg-white/5 px-4 py-3 pr-24 text-sm leading-relaxed outline-none focus:border-blue-500/60 sm:pr-12",
                onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onSend && _ctx.onSend(...args)), ["exact","prevent"]), ["enter"])),
                onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.autoGrow && _ctx.autoGrow(...args))),
                ref: "textareaEl"
              }, null, 544), [
                [_vModelText, _ctx.draft]
              ]),
              _createElementVNode("button", {
                class: "absolute bottom-2 right-2 rounded-xl bg-blue-600 px-3 py-2 text-sm font-semibold text-white hover:bg-blue-500 disabled:opacity-50 sm:top-1/2 sm:bottom-auto sm:-translate-y-1/2",
                disabled: !_ctx.canSend,
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSend && _ctx.onSend(...args)))
              }, " Enviar ", 8, _hoisted_31)
            ]),
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "mt-2 text-xs text-[var(--text-secondary)]" }, " Enter para enviar • Shift+Enter para quebrar linha ", -1))
          ])
        ])
      ])
    ])
  ]))
}